export default __webpack_public_path__ + "static/media/background-mobile.2725494a.svg";